import { createListModalComponent } from 'factories/ListModal'
import Filter from 'containers/Users/Select/Filter'

export default createListModalComponent({
  getStorageKey: (self) => 'selectUser',
  getSettingsType: (self) => 'selectUser',
})(Filter)
